import { useContext, useEffect, useState } from 'react'
import toast, { Toaster } from 'react-hot-toast'
import { http } from '../../AxiosConfig'
import ReimbursementItemCard from '../ReimbursementItemCard/ReimbursementItemCard'
import { useNavigate } from 'react-router-dom'
import './ReviewComponent.css'
import UserCard from '../UserCard/UserCard'
import FormLoader from '../FormLoader/FormLoader'
import { MainContext } from '../MainContext'

const ReviewComponent = () => {
  const [theReimbursement, setTheReimbursement] = useState(null)
  const [theReimbursementItems, setTheReimbursementItems] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [submittSuccesfull, setSubmittSuccesfull] = useState(null)
  const [isDisabled, setIsDisabled] = useState(true)
  const navigate = useNavigate()
  const { reimbursement } = useContext(MainContext)

  useEffect(() => {
    fetchReimbursment()
    if (submittSuccesfull) {
      toast.success('Submitted!')
    }
  }, [submittSuccesfull])

  const patchReimbursment = () => {
    setIsLoading(true)
    const reimbursementId =
      theReimbursement?.id?.length > 0
        ? theReimbursement.id
        : localStorage.getItem('reimbursement_id')
    http
      .patch(
        `/reimbursements/${reimbursementId}`,
        {
          reimbursement: { status: 'submitted' },
        },
      )
      .then(res => {
        setSubmittSuccesfull(res.status)
        // localStorage.removeItem('user_key')
        // localStorage.removeItem('form_value')
        navigate('/Submitted')
      })
      .catch(err => {
        console.log('reimbursement reques err:', err.message)
        toast.error(`Could not process ${err.message} .`)
        setIsLoading(false)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }
  const displayReimbursementItems = () => {
    let items
    if (theReimbursement && theReimbursement?.reimbursement_items.length > 0) {
      items = theReimbursement.reimbursement_items.map((ri, index) => {
        return (
          <ReimbursementItemCard
            fetchReimbursment={fetchReimbursment}
            reimb={theReimbursement}
            key={ri.id}
            item={ri}
            index={index}
          />
        )
      })
    }
    return items
  }
  const fetchReimbursment = () => {
    setIsLoading(true)
    console.log(reimbursement.id)
    const reimbursementId =
      reimbursement?.id?.length > 0
        ? reimbursement.id
        : localStorage.getItem('reimbursement_id')
    if (reimbursementId) {
      http
        .get(`/reimbursements/${reimbursementId}`)
        .then(res => {
          setTheReimbursement(res.data.data.attributes)
          setTheReimbursementItems(res.data.data.attributes.reimbursement_items)
          const reimItemsRes = res.data.data.attributes.reimbursement_items
          if (reimItemsRes && reimItemsRes.length === 0) {
            navigate('/Reimbursement')
          }
        })
        .catch(err => {
          console.log('error:', err.message)
          toast.error(`Can not find reimbursements ${err.message}`)
        })
        .finally(() => {
          setIsLoading(false)
        })
    }
    else {
      window.location.href = '/'
    }
  }
  useEffect(() => {
    // if (Object.keys(user).length === 0) {
    //   return navigate('/')
    // }
  }, [theReimbursement])

  function refreshPage() {
    window.location.reload(false)
    window.location.href = '/'
    localStorage.removeItem('form_value')
  }
  // if (Object.keys(user).length === 0) {
  //   return navigate('/')
  // }
  function addReimburstmentItem() {
    navigate('/Reimbursement')
  }
  if (isLoading) {
    return <FormLoader message="Loading" />
  }
  else if (theReimbursement?.id) {
    return (
      <div className="grid-rows-1">
        <Toaster position="top-center" reverseOrder={false} />
        <article className="card card-light">
          <div className="" id="user-card-div">
            <div className="">
              <UserCard
                user={theReimbursement.user}
                term={theReimbursement.term}
              />
              <div></div>
            </div>
            {displayReimbursementItems()}
            <div style={styleSpace} className="grid">
              {isLoading ? (
                <button disabled={isDisabled}>
                  <FormLoader message={'Submitting'} />
                </button>
              ) : (
                [
                  <button
                    key="button1"
                    onClick={refreshPage}
                    className="primary-button"
                  >
                    Home
                  </button>,
                  <button
                    key="button2"
                    onClick={patchReimbursment}
                    className="primary-button ml-1"
                  >
                    Submit
                  </button>,
                ]
              )}
            </div>
          </div>
        </article>
      </div>
    )
  }
}
export default ReviewComponent
const styleSpace = {
  display: 'flex',
  flexDirection: 'row',
}
